import React from 'react';
import ReactDOM from 'react-dom';
import { MdClose } from 'react-icons/md';
import * as St from './styles';

interface IPictureModal {
  handleClose: () => void;
  children: React.ReactNode;
}

const PictureModal: React.FC<IPictureModal> = ({ handleClose, children }) => {
  const modalContent = (
    <St.Container onClick={handleClose}>
      <St.Modal onClick={(e) => e.stopPropagation()}>
        <span id="close">
          <MdClose size={30} onClick={handleClose} />
        </span>
        {children}
      </St.Modal>
    </St.Container>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default PictureModal;
